var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDribbling(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 37.997,
    height: 38,
    viewBox: "0 0 37.997 38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "DRIBBLING",
    className: "cls-1",
    d: "M-2876.658,6213.525a18.878,18.878,0,0,0-13.436-5.565,18.875,18.875,0,0,0-13.435,5.565,18.875,18.875,0,0,0-5.562,13.175c0,.5,0,.014,0,.52a18.873,18.873,0,0,0,5.562,13.176,18.878,18.878,0,0,0,13.435,5.564,18.881,18.881,0,0,0,13.436-5.564,18.879,18.879,0,0,0,5.564-13.436A18.875,18.875,0,0,0-2876.658,6213.525Zm-25.837,1.032a17.4,17.4,0,0,1,10.488-5.032l-15.522,15.522A17.412,17.412,0,0,1-2902.495,6214.557Zm-5.121,13.134h15.758l-7.91,7.908a.732.732,0,0,0-.159.8.73.73,0,0,0,.675.451h16.55l-7.648,7.646a17.408,17.408,0,0,1-12.146-5.133A17.405,17.405,0,0,1-2907.616,6227.691Zm29.924,11.67a17.4,17.4,0,0,1-10.489,5.034l7.761-7.761a.732.732,0,0,0,.159-.8.728.728,0,0,0-.674-.451h-16.551l7.91-7.909a.733.733,0,0,0,.158-.8.731.731,0,0,0-.675-.452h-16.55l16.8-16.8a17.413,17.413,0,0,1,12.147,5.132,17.431,17.431,0,0,1,5.137,12.4A17.422,17.422,0,0,1-2877.692,6239.361Z",
    transform: "translate(2909.091 -6207.959)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDribbling);
export default __webpack_public_path__ + "static/media/dribbling.19f59ef9993f16e0b7b87eed7862a3ec.svg";
export { ForwardRef as ReactComponent };